<template>
  <div>
        <div class="table_th">
               <div style="width:25%">
                  {{ $t(`lang.str_3200_gameType`) }}
                </div>
                <div style="width:25%">
                  {{ $t(`lang.str_3200_BetX100`) }}
                </div>
                <div style="width:25%">
                  {{ $t(`lang.str_3200_CashOutX`) }}
                </div>
                <div style="width:25%">
                  {{ $t(`lang.str_3200_CrashX`) }}
                </div>
                <div style="width:25%">
                  {{ $t(`lang.str_3200_WinX100`) }}
                </div>
        </div>
        <div v-for="(item, index) in betInfos" :key="index">
              <div class="table_tr">
                <div style="width:25%">
                  <div>{{ item.AutoCashOutX >0 ?($t(`lang.str_3200_Auto`)+item.AutoCashOutX):$t(`lang.str_3200_NOAuto`) }}</div>
                </div>
                <div style="width:25%">
                  <div>{{ (item.BetX100/100).toFixed(2)  }}</div>
                </div>
                <div style="width:25%">
                  <div> {{ item.CashOutX }}x</div>
                </div>
                <div style="width:25%">
                  <div> {{ CrashX }}x</div>
                </div>
                <div style="width:25%">
                  <div> {{ ((item.WinX100-item.BetX100)/100).toFixed(2)}}</div>
                </div>
              </div>
        </div>
        <DescribeLayout
          :winValueTip="winValueTip"
          :winValueTotal="winValueTotal"
          :isTotalWin="isTotalWin"
          :describe_title = "describe_title"
          :describe_content = "describe_content"
          :describe_message="describe_message">
        </DescribeLayout>
  </div>
</template>
<script>
    import DescribeLayout from "../common/describe_layout.vue";

    export default {
        name: 'Game3200',
      components: {DescribeLayout},
        data() {
          return {
          }
        },
        props:{
            winValueTip:null,
            winValueTotal:null,
            isTotalWin:false,
            describe_title:null,
            describe_content:null,
            describe_message:null,
            betInfos:[],
            CrashX:0,
            detail:{},
            lang: '',
            Phone:false,
        },
        computed: {

        },
        created() {

        },
        methods:
        {

       },
    }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/esports/game_3200.vue